import type { SystemConfigGroupEn } from 'src/constants/systemConfig.enum';
import type { SystemSettingAdd } from 'src/types/master_data/systemSetting.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'master-data/system-settings';

export const getSystemSettings = async (group: SystemConfigGroupEn) =>
  await http.get<SystemSettingAdd[]>(`${controller}/${group}`);

export const updateSystemSetting = async (systemSettings: SystemSettingAdd[]) =>
  await http.put<SystemSettingAdd[]>(controller, systemSettings);
